import { StyleSheet } from "react-native";

export default StyleSheet.create({
  overlay: {
    position: "absolute",
    zIndex: 9,
    width: "100%",
    height: "100%",
    backgroundColor: "#0009",
    justifyContent: "center",
    zIndex: 999,
  },
  modal: {
    margin: 10,
    padding: 20,
    borderRadius: 8,
    backgroundColor: "#FFF",
    marginTop: 20,

    overflow: "hidden",

    justifyContent: "center"
  },
  textHeader: {
    color: "#000",
    fontSize: 20,
    marginBottom: 20,
    textAlign: "center",
    fontWeight: "bold",
  },
  text: {
    textAlign: "center",
    marginBottom: 5,
  },
  buttonConfirm: {
    height: 40,
    backgroundColor: "#00AA00",
    borderRadius: 10,
    marginTop: 10,

    alignItems: "center",
    justifyContent: "center",
  },
  textConfirm: {
    color: "#FFF",
    fontWeight: "bold",
  },
  close: { position: "absolute", right: 0, top: 0, padding: 10, fontSize: 20 },
});
